import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'; // Importujte `useSelector` hook za pristup stanju
import { getDocument } from '../actions/uploadAction'; // Importujte akciju za dohvatanje uploadovanih fajlova
import '../screens/staff/ScheduledTaskInfoScreen.css';

const UploadedFilesComponent = ({ scheduledTaskId }) => {
  
  const dispatch = useDispatch();
  
  // Koristite `useSelector` hook za pristup stanju
 
  const documentsState = useSelector((state) => state.documentList);
  const { documents } = documentsState;
 
  
  // Učitavanje uploadovanih fajlova kada se komponenta montira ili kada `scheduledTaskId` promeni
  useEffect(() => {
    if (scheduledTaskId) {
      dispatch(getDocument(scheduledTaskId));
    }
  }, [dispatch, scheduledTaskId]);

  // Funkcija za preuzimanje fajla
  const handleDownload = (file) => {
    
    window.open(file.url,'_blank')
  };

  return (
    <div>
      <h3>Uploaded Files:</h3>
      {/* Provera da li je uploadedFiles definisan pre mapiranja */}
      {documents && documents.length > 0 ? documents.map((file, index) => (
        <div key={index} style={{ marginBottom: '10px', padding: '10px', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px' }}>
          <p style={{ margin: '0 0 10px 0', fontWeight: '500' }}>{file.name}</p> {/* Prikaz naziva fajla */}
          <button 
            onClick={() => handleDownload(file)} 
            className="assignment-button"
            style={{ marginTop: '5px' }}
          >
            Download
          </button> {/* Dugme za preuzimanje */}
        </div>
      )) : (
        <p style={{ fontStyle: 'italic', opacity: '0.7' }}>No documents uploaded yet.</p>
      )}
    </div>
  );
};

export default UploadedFilesComponent;
